import { render } from "./StepForm5.vue?vue&type=template&id=537bdce7&scoped=true"
import script from "./StepForm5.vue?vue&type=script&lang=js"
export * from "./StepForm5.vue?vue&type=script&lang=js"

import "./StepForm5.vue?vue&type=style&index=0&id=537bdce7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537bdce7"]])

export default __exports__